import { Carousel, ConfigProvider } from 'antd';

import styles from './index.module.scss';
import { LocalImage } from '../../Image';
import { useAppSelector } from '../../../state';
import { track } from '../../../track';
import { useCallback } from 'react';
import { WorkSpaceBanner } from '../../../types';

interface IHomeBannerProps {
  bannerList: WorkSpaceBanner[];
  styles: Record<string, string>;
}

const PAGE = 'ugc_main_page';

export function InnerHomeBanner({ bannerList, styles }: IHomeBannerProps) {
  const handleClickBanner = useCallback((banner: WorkSpaceBanner) => {
    track.send('banner_page_click', PAGE, {
      jump_link: banner.jump_url,
      banner_id: banner.banner_id,
    });
    location.href = banner.jump_url;
  }, []);

  const onBannerShow = useCallback((index: number) => {
    track.collect('banner_page_view', PAGE, {
      jump_link: bannerList[index].jump_url,
      banner_id: bannerList[index].banner_id,
    });
  }, []);

  return (
    <ConfigProvider
      theme={{
        components: {
          Carousel: {
            dotWidth: 8,
            dotHeight: 8,
            dotActiveWidth: 8,
          },
        },
      }}
    >
      <Carousel
        className={styles.carousel}
        afterChange={(index) => {
          onBannerShow(index);
        }}
        autoplay
        autoplaySpeed={3000}
        draggable
      >
        {bannerList.map((item, index) => (
          <div
            key={item.jump_url}
            className="cursor-pointer"
            onClick={() => {
              handleClickBanner(item);
            }}
          >
            <LocalImage
              src={item.img_url}
              className={styles.img}
              onClick={() => {
                handleClickBanner(item);
              }}
            />
          </div>
        ))}
      </Carousel>
    </ConfigProvider>
  );
}

export const HomeBanner = () => {
  const { banners } = useAppSelector((state) => state.home);
  return banners.length ? <InnerHomeBanner bannerList={banners} styles={styles} /> : null;
};
